<template>
  <div class="flex flex-col lg:flex-row lg:h-screen flex-1 bg-gray-50 dark:bg-neutral-800">
    <div
      class="bg-gray-100 dark:bg-neutral-950 grow basis-0 flex items-center justify-center p-8 xl:p-20 relative lg:overflow-hidden"
    >
      <!-- <img
        class="hidden lg:block absolute inset-0 z-[1] object-fill h-full w-full -top-[900px] left-1/2 -translate-x-1/2"
        src="~/assets/images/baseball-field2-9x16.png"
        alt=""
      />
      <img
        class="hidden lg:block absolute inset-0 z-[1] object-fill h-full w-full top-[900px] left-1/2 -translate-x-1/2"
        src="~/assets/images/baseball-field-9x16.png"
        alt=""
      /> -->
      <!-- <div
        class="absolute z-[2] top-0 left-0 w-full h-full bg-white/[0.8] dark:bg-neutral-800/[0.75]"
      ></div> -->
      <div class="flex-1 relative z-[3]">
        <HeadingBasic class="text-balance mb-8">Sign up for 64 Analytics</HeadingBasic>
        <div class="text-xl">
          <p class="text-balance mt-5 mb-8">
            Membership grants you unrestricted access to our proprietary ranking system powered by
            the most up-to-date NCAA baseball statistics on the web.
          </p>
          <p class="mb-4">
            Sign up today to start taking advantage of these pro features and more:
          </p>
          <ul class="list-disc pl-4">
            <li v-for="feature in features">{{ feature.name }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="grow basis-0 flex items-center justify-center p-8 xl:p-20">
      <div class="flex-1 max-w-2xl">
        <div v-if="state == 'subscribe'"></div>
        <div
          :class="{
            'opacity-1 relative': state == 'subscribe',
            'opacity-0 absolute': state !== 'subscribe',
          }"
        >
          <HeadingBasic :size="2" class="text-balance">
            Purchase a 64 Analytics Subscription for as little as ${{
              (annualPrice?.unit_amount || 11988) / 12 / 100
            }}
            a month
          </HeadingBasic>
          <p class="mt-2 mb-8">
            Already have an account?
            <NuxtLink class="underline" :to="{ path: '/login' }">Sign In</NuxtLink>
          </p>
          <FormKit type="form" v-model="form" @submit="onSubscribe" :actions="false">
            <FormKitSchema :schema="schema" />
          </FormKit>

          <PricingPlanToggles v-model="form.membershipType" class="mb-5" />
          <TransitionSlideInDown>
            <PricingCheckboxToggles
              v-if="form.membershipType == 'portal'"
              class="my-3"
              v-model="form.sports"
            >
              <template #label>Select Sport(s)</template>
            </PricingCheckboxToggles>
          </TransitionSlideInDown>
          <TransitionSlideInDown>
            <PricingPortalPassLevelToggles
              v-if="form.membershipType == 'portal' && form.sports.length > 0"
              class="mb-5"
              v-model="form.portalPassSeasons"
              v-model:sports="form.sports"
            />
          </TransitionSlideInDown>
          <PricingBillingTypeToggles
            class="mb-5"
            v-if="form.membershipType == 'standard'"
            v-model="form.billingType"
          />
          <div class="border dark:border-white/[0.2] p-4 mb-5">
            <div class="font-bold text-2xl mb-0 max-w-[380px]">
              <template v-if="form.membershipType == 'portal'">
                64 Analytics Portal Pass
                <span class="block mb-3">{{ subscribingText }}</span>
              </template>
              <template v-else>64 Analytics Standard Membership (Free Trial)</template>
            </div>
            <div class="text-xl mb-3">
              <!-- {{ selectedSubscriptionLabels }} -->
              <p>
                {{ selectedSubscriptionLabels.beginningText }}
                <span
                  v-if="
                    selectedSubscriptionLabels.discountedPrice !==
                    selectedSubscriptionLabels.fullPrice
                  "
                  class="after:content-['']"
                  :class="
                    selectedSubscriptionLabels.discountedPrice
                      ? 'text-gray-500 dark:text-gray-400 relative after:block after:h-0.5 after:w-full after:bg-gray-500 after:dark:bg-gray-400 after:absolute after:top-1/2 after:left-0'
                      : ''
                  "
                >
                  ${{ selectedSubscriptionLabels.fullPrice }}
                </span>
                <template v-if="selectedSubscriptionLabels.discountedPrice">
                  <span class="inline-block ml-2">
                    ${{ selectedSubscriptionLabels.discountedPrice }}
                  </span>
                </template>
                {{ selectedSubscriptionLabels.extraText }}
              </p>
            </div>
            <div class="text-sm">
              <template v-if="form.membershipType == 'portal'">
                <PricingPortalConfirm
                  class="mt-5"
                  v-model="portalTermConfirm"
                  :portalPassSeasons="form.portalPassSeasons"
                />
              </template>
              <template v-else>
                {{
                  `Your free trial will end on ${datePlusX(
                    7
                  )}. Add a payment method in the "My Account" page at any time to avoid disruption to your subscription.`
                }}
              </template>
            </div>
          </div>
          <!-- <div>
            <FormKit label="Discount Code" v-model="form.discount_code" />
          </div> -->
          <UButton
            class="w-full bg-cardinal dark:bg-cardinal text-white dark:text-white flex justify-center"
            size="xl"
            :disabled="subscribeSubmitting"
            :loading="subscribeSubmitting"
            @click="onSubscribe"
          >
            <i class="fas fa-lock" />
            Checkout
          </UButton>
        </div>
        <div
          :class="{
            'opacity-1 relative': state == 'checkout',
            'opacity-0 absolute': state !== 'checkout',
          }"
        >
          <HeadingBasic :size="2" class="text-balance mb-5"> Complete Your Purchase </HeadingBasic>
          <p class="mb-5">Almost done, {{ form.firstName }}! Please enter your payment details</p>
          <UCard class="max-w-[600px]"><div id="payment-element"></div></UCard>
          <UButton
            :disabled="paymentIsSubmitting"
            class="w-full bg-cardinal-600 flex items-center mt-3 py-3 justify-center"
            @click="onCheckOut"
            >Confirm Purchase</UButton
          >
        </div>
        <div
          :class="{
            'opacity-1 relative': state == 'success',
            'opacity-0 absolute': state !== 'success',
          }"
        >
          <UCard>
            <HeadingBasic :size="3">Processing Payment</HeadingBasic>
            <p>
              Please do not close this browser. You will be redirected as soon as the request is
              complete.
            </p>
          </UCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Join 64Analytics - Start Your Baseball Analytics Journey',
  meta: [
    {
      name: 'description',
      content:
        'Sign up for 64Analytics and gain access to exclusive baseball stats, rankings, and career-enhancing tools tailored for NCAA players.',
    },
  ],
});

import { type AuthChangeEvent } from '@supabase/gotrue-js/src';
import { FormKit, FormKitSchema } from '@formkit/vue';
import { type Stripe } from 'stripe';
import featuresContent from '~/assets/content/features';
import { loadStripe, type Stripe as StripeClient } from '@stripe/stripe-js';
import { ProfilesService } from '~/lib/services/profiles.service';
import { VALID_ZEROBOUNCE_STATUSES, validateEmail } from '~/lib/services/email-validation';
import type { Database } from '~/types/database.types';
import { startTrial } from '~/lib/trial/start-trial';
const config = useRuntimeConfig();
const supabase = useSupabaseClient<Database>();

definePageMeta({
  middleware: 'redirect-if-logged-in',
});

const {
  public: { baseUrl },
} = useRuntimeConfig();

const { getSubscriptionLabelFromBillingType, annualPrice } = await useSubscriptionPrices();

const profileService = new ProfilesService(supabase);
const features = ref([...featuresContent]);
const toast = useToast();
let stripe: StripeClient | null = null;
const elements = ref();
const state = ref<'subscribe' | 'checkout' | 'success'>('subscribe');
const paymentIsSubmitting = ref(false);

const form = ref<{
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  password_confirm: string;
  membershipType: 'portal' | 'standard';
  billingType: 'annual' | 'monthly';
  portalPassSeasons: 1 | 2 | 3;
  utm_source: string;
  clientele_type: string;
  discount_code: string;
  sports: Sport[];
}>({
  firstName: '',
  lastName: '',
  email: ``,
  phone: '',
  password: '',
  password_confirm: '',
  membershipType: 'standard',
  billingType: 'monthly',
  portalPassSeasons: 1,
  utm_source: '',
  clientele_type: '',
  discount_code: '',
  sports: ['Baseball'],
  // membershipType: 'paid',
});

/**
 * fill form params from query params:
 * membershipType
 * portalPassSeasons
 * utm_source - source in the url params
 */
const route = useRoute();
onMounted(() => {
  // Handle membershipType param
  if (
    route.query.membershipType &&
    ['portal', 'standard'].includes(route.query.membershipType as string)
  ) {
    form.value.membershipType = route.query.membershipType as 'portal' | 'standard';
  }

  if (route.query.discountCode) {
    form.value.discount_code = route.query.discountCode as string;
  }

  // Handle portalPassSeasons param
  const seasons = parseInt(route.query.portalPassSeasons as string);
  if (!isNaN(seasons) && seasons > 0 && seasons <= 3) {
    form.value.portalPassSeasons = seasons as 1 | 2 | 3;
  }
  if (route.query.source) {
    form.value.utm_source = route.query.source as string;
  }
});

const { datePlus30, datePlus365, datePlusX, makeCheckoutSession } = useCheckout();

const selectedSubscriptionLabels = computed(() => {
  return getSubscriptionLabelFromBillingType(
    form.value.membershipType,
    form.value.billingType,
    form.value.portalPassSeasons,
    form.value.sports
  );
});

const schema = computed(() => {
  const arr = [
    // {
    //   $el: 'div',
    //   attrs: {
    //     class: 'flex flex-col md:flex-row gap-3',
    //   },
    //   children: [
    //     {
    //       $el: 'div',
    //       attrs: {
    //         class: 'grow basis-0',
    //       },
    //       children: [
    //         {
    //           $formkit: 'text',
    //           name: 'firstName',
    //           label: 'First Name',
    //           placeholder: 'Enter your first name...',
    //           validation: 'required',
    //         },
    //       ],
    //     },
    //     {
    //       $el: 'div',
    //       attrs: {
    //         class: 'grow basis-0',
    //       },
    //       children: [
    //         {
    //           $formkit: 'text',
    //           name: 'lastName',
    //           label: 'Last Name',
    //           placeholder: 'Enter your last name...',
    //           validation: 'required',
    //         },
    //       ],
    //     },
    //   ],
    // },

    {
      $el: 'div',
      attrs: {
        class: 'flex flex-col md:flex-row gap-3',
      },
      children: [
        {
          $el: 'div',
          attrs: {
            class: 'grow basis-0',
          },
          children: [
            {
              $formkit: 'email',
              name: 'email',
              label: 'Email Address',
              placeholder: 'Enter your email address...',
              innerClass: '!max-w-full',
              validation: 'required|email',
            },
          ],
        },
        // {
        //   $el: 'div',
        //   attrs: {
        //     class: 'grow basis-0',
        //   },
        //   children: [
        //     {
        //       $formkit: 'tel',
        //       name: 'phone',
        //       label: 'Phone Number',
        //       placeholder: 'Enter your phone number...',
        //       validation: 'required|numeric',
        //     },
        //   ],
        // },
      ],
    },
    // {
    //   $el: 'div',
    //   attrs: {
    //     class: 'flex flex-col md:flex-row gap-3',
    //   },
    //   children: [
    //     {
    //       $formkit: 'select',
    //       name: 'utm_source',
    //       label: 'How did you hear about us?',
    //       classes: {
    //         outer: 'grow basis-0',
    //       },
    //       options: [
    //         { value: '', label: 'Select One' },
    //         { value: 'twitter', label: 'Twitter' },
    //         { value: 'instagram', label: 'Instagram' },
    //         { value: 'wordOfMouth', label: 'Word of Mouth' },
    //         { value: 'google', label: 'Google' },
    //         { value: 'other', label: 'Other' },
    //       ],
    //       validation: 'required',
    //     },
    //     {
    //       $formkit: 'select',
    //       name: 'clientele_type',
    //       label: 'Which best describes you?',
    //       classes: {
    //         outer: 'grow basis-0',
    //       },
    //       options: [
    //         { value: '', label: 'Select One' },
    //         { value: 'currentPlayer', label: 'Current Player' },
    //         { value: 'prospectivePlayer', label: 'Prospective Player' },
    //         { value: 'parent', label: 'Parent' },
    //         { value: 'coach', label: 'Coach' },
    //         { value: 'fan', label: 'Fan' },
    //       ],
    //       validation: 'required',
    //     },
    //   ],
    // },
    {
      $el: 'div',
      attrs: {
        class: 'flex flex-col md:flex-row gap-3',
      },
      children: [
        {
          $el: 'div',
          attrs: {
            class: 'grow basis-0',
          },
          children: [
            {
              $formkit: 'password',
              name: 'password',
              label: 'Password',
              help: 'Enter your new password.',
              validation: 'required|length:5,16',
            },
          ],
        },
        {
          $el: 'div',
          attrs: {
            class: 'grow basis-0',
          },
          children: [
            {
              $formkit: 'password',
              name: 'password_confirm',
              label: 'Confirm password',
              help: 'Enter your new password again to confirm it.',
              validation: 'required|confirm',
              validationLabel: 'password confirmation',
            },
          ],
        },
      ],
    },

    // {
    //   $formkit: 'radio',
    //   name: 'membershipType',

    //   label: '$membershipType',
    //   options: [
    //     { value: 'portal', label: 'Portal Pass ' },
    //     { value: 'standard', label: 'Standard' },
    //   ],
    // },
    // {
    //   $cmp: 'PricingPlanToggles',
    //   name: 'membershipType',
    //   props: {
    //     membershipType: form.value.membershipType,
    //   },
    // },
    // {
    //   $formkit: 'radio',
    //   name: 'membershipType',
    //   label: 'Membership Type',
    //   options: [
    //     {
    //       value: 'paid',
    //       label: `64 Analytics Pro Membership - $${
    //         form.value.billingType == 'monthly'
    //           ? ((monthlyPrice.value?.unit_amount || DEFAULT_MONTHLY_PRICE) / 100).toFixed(2)
    //           : ((annualPrice.value?.unit_amount || DEFAULT_ANNUAL_PRICE) / 12 / 100).toFixed(2)
    //       }${form.value.billingType == 'monthly' ? ' billed monthly' : '/mo billed annually'}`,
    //     },
    //     { value: 'free', label: 'Free Account (Limited) - Free' },
    //   ],
    // },
  ];

  // const billingTypeSchema = {
  //   $formkit: 'radio',
  //   name: 'billingType',
  //   label: 'Billing Type',
  //   if: 'true',
  //   options: [
  //     { value: 'annual', label: 'Annual (Save 30%)' },
  //     { value: 'monthly', label: 'Monthly' },
  //   ],
  // };

  // if () {
  //   // insert billingTypeSchema between the index immediately following name == 'membershipType' and the next item currently in the array
  //   arr.splice(5, 0, billingTypeSchema);
  // }

  return arr;
});

supabase.auth.onAuthStateChange((event: AuthChangeEvent) => {
  // console.log('onAuthStateChange :: ', event);
  // toast.add({ title: `Auth state changed: ${event}`, color: 'blue' });
});

const signUpUser = async (email: string, password: string) => {
  const res = await supabase.auth.signUp({
    email,
    password,
    options: {
      emailRedirectTo: `${baseUrl || `http://localhost:3000`}/confirm`,
    },
  });
  if (res.error) {
    throw { code: 500, message: res.error.message };
  }
  return res;
};

const thirtyDaysFromNow = () => {
  const now = new Date();

  // Calculate 30 days in milliseconds (30 days * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
  const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000;

  // Add 30 days to the current date
  const thirtyDaysFromNow = new Date(now.getTime() + thirtyDaysInMilliseconds);

  // Convert the date 30 days from now to a Unix timestamp (seconds since the Unix Epoch)
  return Math.floor(thirtyDaysFromNow.getTime() / 1000);

  return;
};

const daysFromNow = (days: number) => {
  const now = new Date();

  // Calculate 30 days in milliseconds (30 days * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
  const daysInMilliseconds = days * 24 * 60 * 60 * 1000;

  // Add 30 days to the current date
  const futureDate = new Date(now.getTime() + daysInMilliseconds);

  // Convert the date 30 days from now to a Unix timestamp (seconds since the Unix Epoch)
  return Math.floor(futureDate.getTime() / 1000);

  return;
};

const subscribeSubmitting = ref(false);
const onSubscribe = async () => {
  try {
    if (form.value.membershipType == 'portal' && !portalTermConfirm.value) {
      toast.add({
        title: `Please confirm the terms of the 64 Analytics Portal Pass`,
        color: 'yellow',
      });
      return false;
    }

    // Validate that all required environment variables are set
    const requiredEnvVars = [];

    // Basic required variables
    if (!config.public.stripeKey) requiredEnvVars.push('stripeKey');

    // Baseball Portal Pass prices (discounted for 2025)
    if (!config.public.stripePricePortalPassTwentyFiveDiscounted)
      requiredEnvVars.push('stripePricePortalPassTwentyFiveDiscounted');

    // Check sport-specific variables if needed
    if (form.value.sports.includes('Softball')) {
      if (!config.public.stripePriceSoftballPortalPassTwentyFiveDiscounted)
        requiredEnvVars.push('stripePriceSoftballPortalPassTwentyFiveDiscounted');
    }

    // Multi-year variables if needed
    if (form.value.portalPassSeasons >= 2) {
      if (!config.public.stripePricePortalPassTwentySix)
        requiredEnvVars.push('stripePricePortalPassTwentySix');
      if (!config.public.stripeCouponTwoYearPackage)
        requiredEnvVars.push('stripeCouponTwoYearPackage');

      if (form.value.sports.includes('Softball')) {
        if (!config.public.stripePriceSoftballPortalPassTwentySix)
          requiredEnvVars.push('stripePriceSoftballPortalPassTwentySix');
      }
    }

    if (form.value.portalPassSeasons === 3) {
      if (!config.public.stripePricePortalPassTwentySeven)
        requiredEnvVars.push('stripePricePortalPassTwentySeven');
      if (!config.public.stripeCouponThreeYearPackage)
        requiredEnvVars.push('stripeCouponThreeYearPackage');

      if (form.value.sports.includes('Softball')) {
        if (!config.public.stripePriceSoftballPortalPassTwentySeven)
          requiredEnvVars.push('stripePriceSoftballPortalPassTwentySeven');
      }
    }

    if (requiredEnvVars.length > 0) {
      const errorMessage = `Missing required environment variables: ${requiredEnvVars.join(', ')}`;
      console.error(errorMessage);
      toast.add({
        title: 'Configuration error. Please contact support.',
        color: 'red',
      });
      throw new Error(errorMessage);
    }

    // if portal pass is selected, throw an error if the user has not selected at least one sport
    if (form.value.membershipType == 'portal' && !form.value.sports.length) {
      toast.add({
        title: 'Please select at least one sport',
        color: 'red',
      });
      return false;
    }

    // init loading stat
    subscribeSubmitting.value = true;

    const email = form.value.email.toLowerCase();

    /**
     * If there is an existing profile matching the email, send them to Log In
     */
    const foundProfile = await supabase.from('profiles').select(`*`).eq('email', email).limit(1);
    if (!!(foundProfile.data && foundProfile.data[0]?.id)) {
      toast.add({
        title: `The email you've chosen is already taken. Please log in or try a different email`,
        color: 'yellow',
      });
      subscribeSubmitting.value = false;
      return false;
    }

    try {
      const emailValidation = await validateEmail(email);

      if (
        emailValidation instanceof Error ||
        !VALID_ZEROBOUNCE_STATUSES.includes(emailValidation.status)
      ) {
        toast.add({
          title: `The email you've chosen is not valid. Please try a different email`,
          color: 'yellow',
        });
        subscribeSubmitting.value = false;
        return false;
      }
    } catch (error: any) {
      console.error(error);
    }

    stripe = await loadStripe(config.public.stripeKey);

    /**
     * 1) Sign up user (automatically creates profile)
     */
    const { data: authUser } = await signUpUser(email, form.value.password);

    if (!authUser.user?.id) {
      throw { code: 500, message: 'Unknown user ID' };
    }
    /**
     * 2) Create customer in Stripe
     */
    const { data: stripeCustomer, error: stripeCustomerError } = await useFetch<{
      data: Stripe.Response<Stripe.Customer> | null;
      error: any;
    }>('/api/stripe/customer', {
      method: 'POST',
      body: {
        email: form.value.email,
      },
    });

    if (stripeCustomerError.value) throw stripeCustomerError.value;

    if (!authUser.user?.id) throw { code: 500, message: 'Invalid user ID' };
    if (!stripeCustomer.value?.data?.id) throw { code: 500, message: 'Invalid customer ID' };

    /**
     * 3) Attach stripe customer id to profile id in case their email changes
     */
    const profileParams = {
      first_name: form.value.firstName,
      last_name: form.value.lastName,
      phone: form.value.phone,
      utm_source: form.value.utm_source,
      utm_campaign: '',
      clientele_type: form.value.clientele_type,
      stripe_customer_id: stripeCustomer.value.data.id,
    };

    const { error: profileError } = await profileService.update(authUser.user.id, profileParams);

    if (form.value.membershipType == 'standard') {
      /**
       * 4) Send them to checkout with with mode = 'subscription'
       */
      await startTrial(
        form,
        config.public.baseUrl,
        authUser.user.id,
        stripeCustomer.value?.data.id,
        `${config.public.baseUrl}/my-account?action=trial-started`
      );
    } else {
      if (profileError) throw profileError;

      /**
       * 4) Send them to checkout with mode = 'payment'
       */
      const req: Stripe.Checkout.SessionCreateParams = {
        customer: stripeCustomer.value.data.id,
        client_reference_id: authUser.user.id,
        discounts: [],
        line_items: [],
        invoice_creation: {
          enabled: true,
        },
        mode: 'payment',
        payment_intent_data: {
          setup_future_usage: 'off_session',
        },
        success_url: `${config.public.baseUrl}/my-account?checkout_action=set_default_payment_method&session_id={CHECKOUT_SESSION_ID}`,
        cancel_url: `${config.public.baseUrl}/sign-up`,
      };

      // Determine which price IDs to use based on selected sports
      const isMultiSport =
        form.value.sports.includes('Baseball') && form.value.sports.includes('Softball');
      const isSoftballOnly =
        !form.value.sports.includes('Baseball') && form.value.sports.includes('Softball');
      const isBaseballOnly =
        form.value.sports.includes('Baseball') && !form.value.sports.includes('Softball');

      // Add base year (2025) line items based on selected sports
      if (isMultiSport) {
        if (form.value.portalPassSeasons == 1) {
          // Add the two sport package discount
          // req.discounts?.push({
          //   coupon: String(config.public.stripeCouponTwoSportPackage),
          // });
        }
        // For multi-sport, add both baseball and softball products
        // Add baseball 2025 (discounted)
        req.line_items?.push({
          price: String(config.public.stripePricePortalPassTwentyFiveDiscounted),
          quantity: 1,
        });
        // Add softball 2025 (discounted)
        req.line_items?.push({
          price: String(config.public.stripePriceSoftballPortalPassTwentyFiveDiscounted),
          quantity: 1,
        });
      } else if (isSoftballOnly) {
        // Softball only pricing for 2025 (discounted)
        req.line_items?.push({
          price: String(config.public.stripePriceSoftballPortalPassTwentyFiveDiscounted),
          quantity: 1,
        });
      } else {
        // Baseball only pricing for 2025 (discounted)
        req.line_items?.push({
          price: String(config.public.stripePricePortalPassTwentyFiveDiscounted),
          quantity: 1,
        });
      }

      /**
       * Two Year Portal Pass
       * if they selected two season portal pass package, add the discount and the 2026 prices
       */
      if (form.value.membershipType == 'portal' && form.value.portalPassSeasons == 2) {
        // Add the 2026 price(s)
        if (isMultiSport) {
          // Add the two year package discount
          req.discounts?.push({
            coupon: String(config.public.stripeCouponTwoYearTwoSportPackage),
          });
          // For multi-sport, add both baseball and softball products for 2026
          req.line_items?.push({
            price: String(config.public.stripePricePortalPassTwentySix),
            quantity: 1,
          });
          req.line_items?.push({
            price: String(config.public.stripePriceSoftballPortalPassTwentySix),
            quantity: 1,
          });
        } else if (isSoftballOnly) {
          req.discounts?.push({
            coupon: String(config.public.stripeCouponTwoYearPackage),
          });
          // Softball only pricing for 2026
          req.line_items?.push({
            price: String(config.public.stripePriceSoftballPortalPassTwentySix),
            quantity: 1,
          });
        } else {
          req.discounts?.push({
            coupon: String(config.public.stripeCouponTwoYearPackage),
          });
          // Baseball only pricing for 2026 (default)
          req.line_items?.push({
            price: String(config.public.stripePricePortalPassTwentySix),
            quantity: 1,
          });
        }
      }

      /**
       * Three Year Portal Pass
       * if they selected three season portal pass package, add the discount and prices for 2026 and 2027
       */
      if (form.value.membershipType == 'portal' && form.value.portalPassSeasons == 3) {
        // Add the 2026 price(s)
        if (isMultiSport) {
          // Add the three year package discount
          req.discounts?.push({
            coupon: String(config.public.stripeCouponThreeYearTwoSportPackage),
          });
          // For multi-sport, add both baseball and softball products for 2026
          req.line_items?.push({
            price: String(config.public.stripePricePortalPassTwentySix),
            quantity: 1,
          });
          req.line_items?.push({
            price: String(config.public.stripePriceSoftballPortalPassTwentySix),
            quantity: 1,
          });
          // For multi-sport, add both baseball and softball products for 2027
          req.line_items?.push({
            price: String(config.public.stripePricePortalPassTwentySeven),
            quantity: 1,
          });
          req.line_items?.push({
            price: String(config.public.stripePriceSoftballPortalPassTwentySeven),
            quantity: 1,
          });
        } else if (isSoftballOnly) {
          // Add the three year package discount
          req.discounts?.push({
            coupon: String(config.public.stripeCouponThreeYearPackage),
          });
          // Softball only pricing for 2026
          req.line_items?.push({
            price: String(config.public.stripePriceSoftballPortalPassTwentySix),
            quantity: 1,
          });
          // Softball only pricing for 2027
          req.line_items?.push({
            price: String(config.public.stripePriceSoftballPortalPassTwentySeven),
            quantity: 1,
          });
        } else {
          // Add the three year package discount
          req.discounts?.push({
            coupon: String(config.public.stripeCouponThreeYearPackage),
          });
          // Baseball only pricing for 2026 (default)
          req.line_items?.push({
            price: String(config.public.stripePricePortalPassTwentySix),
            quantity: 1,
          });
          // Baseball only pricing for 2027 (default)
          req.line_items?.push({
            price: String(config.public.stripePricePortalPassTwentySeven),
            quantity: 1,
          });
        }
      }

      const { data: checkoutRes, error: checkoutError } = await makeCheckoutSession(req);
      console.log(checkoutRes, checkoutError);
      if (checkoutError.value) throw checkoutError;
      if (checkoutRes.value?.data.url) {
        // open url in a new tab
        window.location.href = checkoutRes.value.data.url;
      }
    }
  } catch (error: any) {
    toast.add({
      title:
        error.message ??
        'There was an error signing up. Please use the chat button in the bottom right of the screen to contact support',
      color: 'red',
      timeout: 30000,
    });
    console.log(error);
    subscribeSubmitting.value = false;
  } finally {
    subscribeSubmitting.value = false;
  }
};

const onCheckOut = async (customerId: string) => {
  paymentIsSubmitting.value = true;
  // 1. confirm payment
  // 3. show thank you confirmation with instructions to check email
  try {
    if (!stripe) {
      console.error('Sign-up :: invalid stripe client');
      /**
       * TODO: Handle incomplete checkout
       */
      return;
    }
    const { error } = await stripe.confirmPayment({
      elements: elements.value,
      confirmParams: {
        return_url: `${config.public.baseUrl}/confirmation`,
      },
    });
    if (error) throw error;
    toast.add({ title: 'Subscription successful', color: 'green' });
    state.value = 'success';
  } catch (error: any) {
    toast.add({ title: error.message, color: 'red' });
    console.log(error);
  } finally {
    paymentIsSubmitting.value = false;
  }
};

onMounted(() => {
  // if we are on localhost, fill billingForm with test data
  if (window.location.hostname === 'localhost') {
    // form.value.firstName = 'John';
    // form.value.lastName = 'Doe';
    // // put in an email in this format jeremyh8878+<unixtimestamp>@gmail.com
    form.value.email = `jeremyh8878+${Date.now()}@gmail.com`;
    // form.value.phone = '555-555-5555';
    form.value.password = 'testing';
    form.value.password_confirm = 'testing';
    // form.value.utm_source = 'twitter';
    // form.value.clientele_type = 'currentPlayer';
  } else {
    console.log(window.location.hostname);
  }
});
const portalTermConfirm = ref<boolean>(false);

const subscribingText = computed(() => {
  if (form.value.portalPassSeasons === 1) {
    return '2025 Season';
  }
  if (form.value.portalPassSeasons === 2) {
    return '2025 & 2026 Seasons';
  }
  if (form.value.portalPassSeasons === 3) {
    return '2025, 2026 & 2027 Seasons';
  }
});
</script>
